<div class="settings-container">
    <div *ngIf="selectedReport.id && dataLoaded">
        <div class="section-title">
            {{ 'dashboard:Settings' | i18next }}
        </div>
        <div class="section">
            <div class="properties-row">
                <div class="half-row flex">
                    <div *ngIf="serviceNumbers?.length>0" class="property shrink">
                        <div class="title" [class.active]="serviceNumbersIsOpen">{{ 'dashboard:Service Number' | i18next
                            }}
                        </div>
                        <ng-select [items]="serviceNumbers" bindLabel="key" bindValue="value"
                            [(ngModel)]="gridItem.setup.serviceNumber" placeholder="{{ 'Select'| i18next }}"
                            [searchable]="false" (open)="serviceNumbersIsOpen=true;"
                            (close)="serviceNumbersIsOpen=false" (change)="modelChange()">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index"
                                dropdownPosition="bottom">
                                <span class="item">{{item.value}}</span>
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                <span class="item">{{item?.value}}</span>
                            </ng-template>
                        </ng-select>
                    </div>
                    <app-widget-report-columns-select class="grow" [items]="columns" bindLabel="shortDescription"
                        [model]="gridItem.setup.columns" [defaultColumns]="defaultColumns"
                        title="{{ 'dashboard:Select Columns' | i18next }}" bindValue="labelCode"
                        (modelChange)="selectModelChange($event,'columns')">
                    </app-widget-report-columns-select>
                </div>
                <app-widget-type-select [widgetType]="gridItem.type" (modelChange)="gridItem.type=$event"
                    [showTooltip]="true" class="half-row" (modelChange)="modelChange()"
                    title="{{ 'dashboard:Visual Type' | i18next }}" [disabledItems]="visualTypedisabledItems"
                    hideLabelType="true">
                </app-widget-type-select>
            </div>
            <div class="properties-row" *ngIf="selectedReport.id">
                <div class="width100pct">
                    <div class="period-title">{{ 'dashboard:For Period' | i18next }}</div>
                    <div class="width100pct flex">
                        <div class="half-row">
                            <div class="label">{{ 'dashboard:From' | i18next }}</div>
                            <div class="flex mr5">
                                <app-relative-date-select [gridItem]="gridItem" model="from"
                                    [(completed)]="relativeFromCompleted" (completedChange)="modelChange()" class="grow"
                                    [reportMaxDays]="this.selectedReport?.dataAvailableFor">
                                </app-relative-date-select>
                            </div>
                        </div>
                        <div class="half-row">
                            <div class="label">{{ 'dashboard:To' | i18next }}</div>
                            <div class="flex">
                                <app-relative-date-select [gridItem]="gridItem" model="to"
                                    [(completed)]="relativeToCompleted" (completedChange)="modelChange()" class="grow"
                                    [reportMaxDays]="this.selectedReport?.dataAvailableFor">
                                </app-relative-date-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="properties-row" *ngIf="sysGroupByTime?.length>0">
                <div class="half-row">
                    <div class="mr5">
                        <div class="title ml5">{{ 'dashboard:Group by time' | i18next }}</div>
                        <ng-select [items]="sysGroupByTime" bindLabel="value" bindValue="key"
                            [(ngModel)]="gridItem.setup.sysGroupByTime" placeholder="{{ 'Select'| i18next }}"
                            [searchable]="false" class="group-select">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index"
                                dropdownPosition="bottom">
                                <span>{{item.value}}</span>
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                <span class="item">{{item?.value}}</span>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div *ngIf="isTimeRangeVisible()" class="half-row">
                    <div class="mr5">
                        <mat-checkbox class="checkbox" id="limit" [checked]="limitRange"
                        (change)="limitRangeClick()">Limit time range (00:00-24:00)</mat-checkbox>
                        <!-- <input type="checkbox" id="limit" [checked]="limitRange" (click)="limitRangeClick()" />
                        <label for="limit">Limit time range (00:00-24:00)</label> -->
                        <button mat-flat-button [ngClass]="['primary-button', 'advSettButt']"
                            (click)="showDateFilters()">Advanced settings</button>
                    </div>
                </div>
            </div>
            <div class="properties-row" *ngIf="sysGroupByTime?.length===0 && isTimeRangeVisible()">
                <div class="half-row">
                    <div class="mr5">
                        <mat-checkbox class="checkbox" id="limit" [checked]="limitRange"
                        (change)="limitRangeClick()">Limit time range (00:00-24:00)</mat-checkbox>
                        <!-- <input type="checkbox" id="limit" [checked]="limitRange" (click)="limitRangeClick()" />
                        <label for="limit">Limit time range (00:00-24:00)</label> -->
                        <button mat-flat-button [ngClass]="['primary-button', 'advSettButt']"
                            (click)="showDateFilters()">Advanced settings</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-title" *ngIf="sysDimsForFilter?.length>0">
            {{ 'dashboard:Filter' | i18next }}
        </div>

        <div class="properties-row section flex wrap" *ngIf="sysDimsForFilter?.length>0">
            <div class="half-row" *ngIf="sysDimsForFilter.indexOf('A')>-1">
                <div class="flex">
                    <app-widget-report-select [items]="agents$|async" bindLabel="fullName" [model]="gridItem.setup.A"
                        title="{{ 'dashboard:Select Agents' | i18next }}" bindValue="agentId"
                        [(exclude)]="gridItem.setup.excludeA" (modelChange)="selectModelChange($event,'A')"
                        class="filter-select">
                    </app-widget-report-select>
                </div>
            </div>
            <div class="half-row" *ngIf="sysDimsForFilter.indexOf('G')>-1">
                <div class="flex">
                    <app-widget-user-group-select [items]="userGroupsRes" bindLabel="usergroupName"
                        [model]="gridItem.setup.G" title="{{ 'dashboard:Select User Groups' | i18next }}"
                        bindValue="usergroupId" [(exclude)]="gridItem.setup.excludeG"
                        (modelChange)="selectModelChange($event,'G')" class="filter-select">
                    </app-widget-user-group-select>
                </div>
            </div>
            <div class="half-row" *ngIf="sysDimsForFilter.indexOf('Q')>-1">
                <div class="flex">
                    <app-widget-report-select [items]="queues$|async" bindLabel="description" [model]="gridItem.setup.Q"
                        title="{{ 'dashboard:Select Queues' | i18next }}" bindValue="queueKey"
                        [(exclude)]="gridItem.setup.excludeQ" (modelChange)="selectModelChange($event,'Q')"
                        class="filter-select">
                    </app-widget-report-select>
                </div>
            </div>
            <div class="half-row" *ngIf="sysDimsForFilter.indexOf('T')>-1">
                <div class="flex">
                    <app-widget-select [items]="terminatingNumbers$|async" bindLabel="terminNumber"
                        [model]="gridItem.setup.T" title="{{ 'dashboard:Select Terminating Numbers' | i18next }}"
                        bindValue="terminNumber" [(exclude)]="gridItem.setup.excludeT"
                        (modelChange)="selectModelChange($event,'T')" class="filter-select">
                    </app-widget-select>
                </div>
            </div>
            <div class="half-row" *ngIf="sysDimsForFilter.indexOf('M')>-1">
                <div class="flex">
                    <app-widget-report-select [items]="menus$|async" bindLabel="description" [model]="gridItem.setup.M"
                        title="{{ 'dashboard:Select Menus' | i18next }}" bindValue="menueId"
                        [(exclude)]="gridItem.setup.excludeM" (modelChange)="selectModelChange($event,'M')"
                        class="filter-select">
                    </app-widget-report-select>
                </div>
            </div>
            <div class="half-row half-row-checkbox" *ngIf="sysAgentNoCalls">
                <div class="flex">
                    <mat-checkbox class="checkbox" id="elAgentNoCalls" [checked]="gridItem.setup.sysAgentNoCalls"
                        (change)="changeSysAgentNoCalls($event)">{{sysAgentNoCalls.prompt}}</mat-checkbox>
                    <!-- <label for="elAgentNoCalls">{{sysAgentNoCalls.prompt}}</label>
                <input type="checkbox" id="elAgentNoCalls" [(ngModel)]="gridItem.setup.sysAgentNoCalls" /> -->
                </div>
            </div>
            <div class="half-row half-row-checkbox" *ngIf="sysShowEmpty">
                <div class="flex">
                    <mat-checkbox class="checkbox" id="elShowEmpty" [checked]="gridItem.setup.sysShowEmpty"
                    (change)="changeExlRowQName($event)">{{sysShowEmpty.prompt}}</mat-checkbox>
                    <!-- <label for="elShowEmpty">{{sysShowEmpty.prompt}}</label>
                    <input type="checkbox" id="elShowEmpty" [(ngModel)]="gridItem.setup.sysShowEmpty" /> -->
                </div>
            </div>
            <div class="half-row">
                <div class="flex">
                    <app-widget-report-select [items]="accesspoints" bindLabel="description" [model]="gridItem.setup.N"
                        *ngIf="sysDimsForFilter.indexOf('N')>-1" title="{{ 'dashboard:Select Accesspoint' | i18next }}"
                        bindValue="accesspoint" [(exclude)]="gridItem.setup.excludeN"
                        (modelChange)="selectModelChange($event,'N')" class="filter-select">
                    </app-widget-report-select>
                </div>
            </div>
        </div>
        <div>
            <button *ngIf="isStandAlone" mat-flat-button color="primary" (click)="showReport()"
                [disabled]="!readyToShowReport">
                {{ 'Render' | i18next }}
            </button>
            <button *ngIf="isStandAlone" mat-flat-button color="primary" (click)="saveAsReport()" class="right">
                {{ 'Save as' | i18next }}
            </button>
            <button *ngIf="isStandAlone && report.isCustom" mat-flat-button color="primary" (click)="saveReport()"
                class="right">
                {{ 'Save' | i18next }}
            </button>
            <button *ngIf="isStandAlone && report.isCustom && canEdit" mat-flat-button color="primary"
                (click)="editReport()" class="right">
                {{ 'Edit' | i18next }}
            </button>
        </div>
    </div>
    <div *ngIf="!dataLoaded" class="data-loading">
        <i class="fal fa-sync fa-spin --fa-animation-duration:2s;"></i>
        <span>{{ 'dashboard:Loading' | i18next }}...</span>
    </div>
</div>